import { MenuItem, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLightningLayerEnabled } from 'features/mapping/hooks/useLightningLayerEnabled';
import { useLightningToolsState } from 'state/useLightningToolsState';
import { useAuthState } from 'state/useAuthState';
import { useMapContext } from 'features/mapping/components/Map/MapContext';
import { Link } from 'react-router-dom';
import { UserStatusChip } from 'components/UserStatusChip';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { MapToolsMenuItemProps } from './types';

export const LightningToolsMenuItem = (
  props: MapToolsMenuItemProps,
): JSX.Element | null => {
  const { onClick, padding } = props;
  const { t } = useTranslation();
  const { showMembershipProFeatures } = useAuthState();
  const { showLightningLayer, showInternalLightningLayer } =
    useLightningLayerEnabled();
  const {
    policy: { allowLightningControl },
  } = useMapContext();
  const { toggle } = useLightningToolsState();
  const pinImprovements = useReleaseFlag('pin_drop_improvements');

  if (!showLightningLayer) {
    return null;
  }

  // Without the pin-drop improvements, keep the item hidden for non-pro users.
  if (!pinImprovements && !showMembershipProFeatures) {
    return null;
  }

  const linkToPaywall = pinImprovements && !showMembershipProFeatures;

  const label = (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography component="span" sx={{ lineHeight: 1 }}>
        {t('map.contextMenu.lightningToolsBtnTitle')}
      </Typography>
      {pinImprovements && (
        <UserStatusChip
          type={showInternalLightningLayer ? 'internal' : 'pro'}
          size="small"
        />
      )}
    </Stack>
  );

  if (linkToPaywall) {
    return (
      <MenuItem
        component={Link}
        disabled={!allowLightningControl}
        to="/support_us?plan=pro_yearly&source=lightning_tools"
        sx={{ padding }}
      >
        {label}
      </MenuItem>
    );
  }

  return (
    <MenuItem
      disabled={!allowLightningControl}
      onClick={() => {
        toggle();
        onClick();
      }}
      sx={{ padding }}
    >
      {label}
    </MenuItem>
  );
};
